<template>
  <div class="info-wrapper px-4" v-if="infoData">
    <h2 class=" fs-5 pb-3 mb-3 border-bottom">基本信息</h2>
    <div class=" d-flex align-items-center mb-3">
      <div class=" width-100 rounded-circle overflow-hidden me-5 bg-light" style="height:100px;">
        <img :src="infoData.avatar ? infoData.avatar + '?x-oss-process=style/small-3x' : 'https://img01.wanfangche.com/public/upload/202001/21/5e269da3a3be4.png?x-oss-process=style/avatar'" alt="" class=" w-100">
      </div>
      <click-upload :btnTitle="'修改头像'" @OnImgChange="OnImgChange"></click-upload>
    </div>
    <div class=" d-flex py-3  align-items-center">
      <div class=" width-100 text-muted me-5">昵称</div>
      <div><el-input v-model="infoData.nickname" class=" width-250"></el-input></div>
    </div>
    <div class=" d-flex py-3  align-items-center">
      <div class=" width-100 text-muted me-5">手机号</div>
      <div>{{phoneShow(infoData.tel)}}</div>
    </div>
    <div class=" d-flex py-3  align-items-center">
      <div class=" width-100 text-muted me-5">性别</div>
      <div>
        <el-radio-group v-model="infoData.sex">
          <el-radio label="1">男</el-radio>
          <el-radio label="2">女</el-radio>
        </el-radio-group>
      </div>
    </div>
    <div class=" d-flex py-3  align-items-center">
      <div class=" width-100 text-muted me-5">生日</div>
      <div>
        <el-date-picker
          v-model="infoData.birthday"
          type="date"
          class="width-250"
          value-format="yyyy-MM-dd"
          placeholder="选择日期">
        </el-date-picker>
      </div>
    </div>
    <div class="py-3">
      <el-button type="primary" round :disabled="isEdit()" @click="submit" style="width:200px;">保存</el-button>
    </div>
    <h2 class=" fs-5 mt-4 border-bottom pb-3">账户安全</h2>
     <div class=" d-flex  my-2 py-3  align-items-center ">
      <div class=" width-100 text-muted me-5">密码设置</div>
      <div>
        <el-button round size="small" class=" width-100">
          <router-link :to="{path: './setting_p'}">修改密码</router-link>
        </el-button>
      </div>
    </div>
  </div>
</template>
<script>
import UserService from '../../service/UserService'
import ClickUpload from '../../components/img-upload/click-upload.vue'
import {
  mapActions
} from "vuex";
export default {
  components: {
    ClickUpload
  },
  data () {
    return {
      infoData: null,
      oldData: ''
    }
  },
  methods: {
    ...mapActions(["saveToken"]),
    getUser () {
      UserService.getInfo().then(res => {
        this.infoData = res.data.data
        this.oldData = JSON.stringify(res.data.data)
        UserService.auth().then(res => {
          this.saveToken({
            token: res.headers.authorization
          });
        })
      })
    },
    isEdit () {
      if (JSON.stringify(this.infoData) == this.oldData) {
        return true
      } else {
        return false
      }
    },
    submit () {
      const msg = this.isMsg()
      if (msg) {
        this.$notify({
          title: "提示",
          message: msg,
          type: "warning",
        });
      } else {
        UserService.edit(this.infoData).then(res => {
          this.$notify({
            title: "成功",
            message: '您的信息以修改完成',
            type: "success",
          });
          this.getUser()
        })
      }
    },
    isMsg () {
      if (this.infoData.nickName == '') {
        return '请填写您的昵称'
      }
    },
    phoneShow (tel) {
      return tel.replace(/(\d{3})\d{4}(\d{4})/, "$1****$2");
    },
    OnImgChange (data) {
      if (data) {
        this.infoData.avatar = data[0].response_url
        this.submit()
      }
    }
  },
  mounted () {
    this.getUser()
  }
}
</script>